import { render } from "./HandlingTypeSpecificationModal.vue?vue&type=template&id=21ce4515"
import script from "./HandlingTypeSpecificationModal.vue?vue&type=script&lang=js"
export * from "./HandlingTypeSpecificationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__